var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          actions: _vm.headers.actions,
          "left-side-class": "col-xl-4 pb-2",
          page: _vm.headers.page,
          "right-side-class":
            "col-xl-8 align-items-end d-flex pb-4 justify-content-end"
        }
      }),
      _c("div", { staticClass: "row my-2" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("section-title", {
              attrs: { "has-line": "", title: "Información General" }
            })
          ],
          1
        ),
        _c("div", { staticClass: "mb-2 col-12 d-flex flex-column" }, [
          _c("label", { staticClass: "text-muted" }, [
            _vm._v("Nombre de Cuestionario:")
          ]),
          _c("span", [_vm._v(_vm._s(_vm.model.questionnaireType?.name))])
        ]),
        _c("div", { staticClass: "mb-2 col-3 d-flex flex-column" }, [
          _c("label", { staticClass: "text-muted" }, [
            _vm._v("Año Académico:")
          ]),
          _c("span", [_vm._v(_vm._s(_vm.model.academicYear?.name))])
        ]),
        _c("div", { staticClass: "mb-2 col-3 d-flex flex-column" }, [
          _c("label", { staticClass: "text-muted" }, [_vm._v("Área:")]),
          _c("span", [_vm._v(_vm._s(_vm.model.area?.name))])
        ]),
        _c("div", { staticClass: "mb-2 col-3 d-flex flex-column" }, [
          _c("label", { staticClass: "text-muted" }, [
            _vm._v("Servicio a Ofrecer:")
          ]),
          _c("span", [_vm._v(_vm._s(_vm.model.service?.name))])
        ]),
        _c(
          "div",
          { staticClass: "mb-2 col-3 d-flex flex-column" },
          [
            _c("label", { staticClass: "text-muted" }, [_vm._v("Estatus:")]),
            _c("custom-balloon", {
              attrs: {
                "background-color": _vm.model.status?.color,
                dot: "",
                text: _vm.model.status?.name
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row my-2" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("sections-config", {
              ref: "sections",
              attrs: {
                input: _vm.model.sections,
                "is-read-only": _vm.isReadOnly
              },
              on: {
                "update:input": function($event) {
                  return _vm.$set(_vm.model, "sections", $event)
                }
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }